import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import AIButton from 'ai-components-ui-library/components/buttons/AIButton';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
// @ts-expect-error not converted yet
import { getEditTemplateUrl } from '../../redux/selectors/postSettingsSelectors';
import { NARRATION_KB_ARTICLE_URL } from './TemplateModuleWarning';
import GenerationDisabledTooltip from './GenerationDisabledTooltip';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AudioPanelFooter = ({
  audioUrl,
  executionId,
  hasBlogAudioModule,
  isGenerativeAiEnabled,
  isFileFetchFailed,
  isGenerationPending,
  isInputTextEmpty,
  isOverCharLimit,
  isRemovePending,
  isSaveToFilesPending,
  onAddToPost,
  onCancel,
  onClickGenerate,
  onClose,
  textToAudioFileId
}) => {
  const editTemplateUrl = useSelector(getEditTemplateUrl);
  if (isGenerationPending) {
    return /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsx(AIButton, {
        usageTracker: UsageTracker.getTracker(),
        use: "secondary",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "audioNarration.panel.cancel"
        })
      })
    });
  }
  const addToBlogPostDisabled = !audioUrl || isSaveToFilesPending || !hasBlogAudioModule;
  const generateDisabled = !isGenerativeAiEnabled || isInputTextEmpty || isOverCharLimit || isGenerationPending || isSaveToFilesPending;
  if (isRemovePending || isSaveToFilesPending) {
    return /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    });
  }
  return /*#__PURE__*/_jsxs(DialogFooter, {
    children: [audioUrl && executionId && /*#__PURE__*/_jsx(Tooltip, {
      disabled: hasBlogAudioModule,
      use: "longform",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("h5", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "audioNarration.disabledTooltip.title"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "audioNarration.disabledTooltip.message_jsx",
            elements: {
              UILink: Link
            },
            options: {
              editTemplateUrl,
              betaDocUrl: NARRATION_KB_ARTICLE_URL
            }
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "audioNarration.disabledTooltip.download_jsx",
            elements: {
              UILink: Link
            },
            options: {
              downloadUrl: audioUrl,
              onClick: () => {
                UsageTracker.track('audioNarration', {
                  action: 'download-audio'
                });
              }
            }
          })
        })]
      }),
      onOpenChange: e => {
        if (e.target.value) {
          UsageTracker.track('audioNarration', {
            action: 'show-save-disabled-tooltip'
          });
        }
      },
      children: /*#__PURE__*/_jsx(Button, {
        disabled: addToBlogPostDisabled,
        use: "primary",
        "data-test-id": "narration-save",
        onClick: () => void onAddToPost(),
        children: textToAudioFileId ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "audioNarration.panel.apply"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "audioNarration.panel.addToBlogPost"
        })
      })
    }), (!textToAudioFileId || isFileFetchFailed) && !audioUrl && /*#__PURE__*/_jsx(GenerationDisabledTooltip, {
      isGenerativeAiEnabled: isGenerativeAiEnabled,
      children: /*#__PURE__*/_jsx(AIButton, {
        featureCategoryId: "blog-editor-generate-audio",
        disabled: generateDisabled,
        usageTracker: UsageTracker.getTracker(),
        use: "primary",
        onClick: onClickGenerate,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "audioNarration.panel.generate"
        })
      })
    }), !audioUrl && textToAudioFileId && /*#__PURE__*/_jsx(Button, {
      use: "primary",
      onClick: onClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "audioNarration.panel.done"
      })
    })]
  });
};
export default AudioPanelFooter;